import React from 'react'
import { Button, Modal } from 'react-bootstrap'
import PropTypes from 'prop-types'

const UpdateUserModal = ({ user, show, onClose, onSubmit, updateUserState }) => {
  return (
    <Modal
      show={show}
      onHide={onClose}
      size='xl'
    >
      <Modal.Header closeButton>
        <h4>{user.status === 'ACTIVE' ? 'Inactivate' : 'Activate'} {user.email}</h4>
      </Modal.Header>
      <Modal.Body className='font-85'>
        Are you sure you want to make this user {user.status === 'ACTIVE' ? 'inactive' : 'active'}?
      </Modal.Body>
      <Modal.Footer>
        <Button variant='secondary' onClick={onClose} className='font-85'>
          Cancel
        </Button>
        <Button 
          variant='primary' 
          onClick={() => onSubmit(user.status === 'ACTIVE' ? 'INACTIVE' : 'ACTIVE')} 
          className='font-85'
          disabled={updateUserState.loading}
        >
          Update
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

UpdateUserModal.propTypes = {
  show: PropTypes.bool,
  onClose: PropTypes.func,
  user: PropTypes.shape({
    userId: PropTypes.number,
    email: PropTypes.string,
    status: PropTypes.string
  }),
  onSubmit: PropTypes.func,
  updateUserState: PropTypes.shape({
    loading: PropTypes.bool,
    success: PropTypes.bool,
    error: PropTypes.oneOfType([
      PropTypes.bool,
      PropTypes.string,
      PropTypes.shape({
        message: PropTypes.string
      })
    ])
  }),
}

export default UpdateUserModal
